import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
// Should pass 'desc' if sorting is needed in descending order
@Pipe({
    name: 'sort'
})
export class SortPipe implements PipeTransform {
    transform(array: any[], field: any, order: string): any[] {
        if (array !== undefined) {
            const newArray = _.orderBy(array, [a => a[field].toLowerCase()], [field]);
            if (order === 'desc') {
                return _.reverse(newArray);
            } else {
                return newArray;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/sort.pipe.ts